import React from "react";
import { useNavigate } from "react-router-dom";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import BtnVerify from "../../buttons/BtnVerify";

const Verify = () => {
  const [loading, setloading] = React.useState(false);
  const username = React.useRef();
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  React.useEffect(() => {
    localStorage.clear();
    context.setvalues({ ...context.values, main_menu: undefined });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const _login = async () => {
    try {
      setloading(true);
      const uname = username.current.value;
      if (is_null(uname)) {
        swal("warning", "Please fill the form properly");
        setloading(false)
        return;
      }
      const req = await axiospost("ms_applicant/codeverify", {
        code: uname,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { type, message } = req.data;
      swal(type, message);
      navigate("/");
    } catch ({ message }) {
      swal("warning", message);
    }
    setloading(false);
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-7 mx-auto">
              <div className="auth-form-light text-left py-3 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <img src="images/logo.png" alt="logo" />
                </div>
                <div className="text-center">
                  <h4>Kebbi State Polytechnic Dakingari</h4>
                  <h6 className="font-weight-light text-uppercase">Admission Application Portal</h6>
                  <h6 className="font-weight-light">APPLICANT ACCOUNT VERIFICATION</h6>
                </div>
                <div className="pt-3">
                  <div className="form-group">
                    <label htmlFor="emailaddress">Enter verification code sent to your email address</label>
                    <input type="email" className="form-control form-control-lg" id="emailaddress" placeholder="Verification Code" ref={username} />
                  </div>

                  <div className="mt-3">
                    {!loading && (
                      <button className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" onClick={_login}>
                        Verify Account
                      </button>
                    )}
                    {loading && <button className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">Please wait...</button>}
                  </div>
                  <div className="mt-3 text-right">
                    <BtnVerify />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
